import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

export const GET_SERVICE_STYLISTS = 'GET_SERVICE_STYLISTS';
export const GET_SERVICE_STYLISTS_SUCCESS = 'GET_SERVICE_STYLISTS_SUCCESS';
export const GET_SERVICE_STYLISTS_FAILURE = 'GET_SERVICE_STYLISTS_FAILURE';

export const fetchGetServiceStylists = () => ({
  type: GET_SERVICE_STYLISTS,
});

export const fetchGetServiceStylistsSuccess = (data) => ({
  type: GET_SERVICE_STYLISTS_SUCCESS,
  payload: data,
});

export const fetchGetServiceStylistsFailure = (error) => ({
  type: GET_SERVICE_STYLISTS_FAILURE,
  payload: error,
});

export const getServiceStylistsCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetServiceStylists(data, external));
    try {
      const response = await getMethodWithToken(
        url.getServiceStylists + external?.serviceId + '/stylists/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetServiceStylistsSuccess(response.data));
        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetServiceStylistsFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetServiceStylistsFailure(error.message));
    }
  };
};
